import { formatDateWithMonth } from 'ns_libs/formatter';
import React from 'react';
import { IDealDocument } from 'views/DocumentLibrary/types';
import RecentDocumentCard from './RecentDocumentCard/RecentDocumentCard';

export interface IRecentlyOpenedDocumentsProps {
    recentlyViewedDocuments?: IDealDocument[]
    handleDocumentSelect: (documentId: number) => void
    handleDeleteDocument: (documentId: number) => void
    handleDocumentEdit: (documentId: number) => void
}

const RecentlyOpenedDocuments = ({
    recentlyViewedDocuments, handleDocumentSelect, handleDeleteDocument, handleDocumentEdit,
}: IRecentlyOpenedDocumentsProps) => (
    recentlyViewedDocuments && (
        <>
            <span className="mb-1">Recently opened</span>
            <div className="d-flex align-items-center">
                {recentlyViewedDocuments.map(doc => (
                    <RecentDocumentCard
                        key={`recently-viewed-document-card-${doc.id}`}
                        filename={doc.name}
                        format={doc.extension}
                        uri={doc.s3Url}
                        dateModified={formatDateWithMonth(doc.updatedAt)}
                        selectDocument={() => handleDocumentSelect(doc.id)}
                        onDeleteDocument={() => handleDeleteDocument(doc.id)}
                        onEditDocument={() => handleDocumentEdit(doc.id)}
                    />
                ))}
            </div>
            <div className="separator my-2" />
        </>
    )
);

export default RecentlyOpenedDocuments;
